import React from 'react'
import { Box, Button, Typography, Chip } from '@mui/material'
import { SyncAlt as SyncIcon, Close as ClearIcon } from '@mui/icons-material'
import { poolwerxColors } from '../../../../theme/colors'

interface ReportBulkActionsToolbarProps {
  selectedCount: number
  onBulkSync: () => void
  onClearSelection: () => void
  variant?: 'fixed' | 'sticky'  // 'fixed' for regular view, 'sticky' for fullscreen dialog
}

const ReportBulkActionsToolbar: React.FC<ReportBulkActionsToolbarProps> = ({
  selectedCount,
  onBulkSync,
  onClearSelection,
  variant = 'fixed',
}) => {
  if (selectedCount === 0) return null

  const isFixed = variant === 'fixed'

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: isFixed ? 4 : 2,
        py: isFixed ? 1.5 : 1,
        backgroundColor: '#d0d0d0',
        borderBottom: '2px solid #9e9e9e',
        boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
        ...(isFixed ? {
          position: 'fixed',
          top: 0,
          left: '280px',  // Account for admin sidebar width
          right: 0,
          zIndex: 1200,
          transition: 'all 0.3s ease-in-out',
        } : {
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Chip
          label={`${selectedCount} FP${selectedCount !== 1 ? 's' : ''} selected`}
          size="small"
          sx={{
            backgroundColor: poolwerxColors.teal,
            color: 'white',
            fontWeight: 600,
            fontSize: '0.8125rem',
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="small"
          variant="contained"
          startIcon={<SyncIcon />}
          onClick={onBulkSync}
          sx={{
            bgcolor: poolwerxColors.teal,
            '&:hover': { bgcolor: poolwerxColors.teal, opacity: 0.9 },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          Bulk Sync
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ClearIcon />}
          onClick={onClearSelection}
          sx={{
            borderColor: poolwerxColors.red,
            color: poolwerxColors.red,
            textTransform: 'none',
            '&:hover': {
              borderColor: poolwerxColors.redHover,
              bgcolor: poolwerxColors.redLight,
            },
          }}
        >
          Clear Selection
        </Button>
      </Box>
    </Box>
  )
}

export default ReportBulkActionsToolbar
